import styled, { css } from 'styled-components'

interface IWrapperProps {
  matches?: boolean
  justifyContent?: string
  marginOff?: boolean
}

export const Wrapper = styled.div<IWrapperProps>(
  ({ theme, matches, justifyContent, marginOff }) => css`
    width: 100%;
    margin: ${marginOff
      ? '0'
      : `${theme.layout.margin.big} 0 ${theme.layout.margin.small} 0`};
    display: flex;
    flex-direction: ${matches ? 'row' : 'column'};
    align-items: center;
    justify-content: ${justifyContent || 'flex-end'};
    gap: ${matches
      ? theme.layout.defaultSpacing.medium
      : theme.layout.defaultSpacing.small};
  `
)
